<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :active-tab="activeTab"
    :action-type="actionType"
    :saveIsDisabled="!required.filled"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
          />
        </template>
      </div>
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import InputField from "../_Molecules/InputField";
import { listsMixin } from "@/mixins/listsMixin";
import { bus } from "@/main.js";

export default {
  name: "VirtualForm",

  components: {
    InputField,
    DynamicObjectFormStructure
  },

  mixins: [dynamicObjectFormsMixin, listsMixin],

  props: {
    /**
     */
    linkObjectToPathway: {
      type: Object
    }
  },

  methods: {
    createObject() {
      this.createDataToSend();

      this.CREATE_OBJECTS({
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      })
        .then(technicalPointData => {
          if (this.linkObjectToPathway.split) {
            bus.$emit("reset-pathway-and-split-data");
          }

          this.objectData.tp_label = this.incrementLabelSequential(
            this.objectData.tp_label
          );

          this.finishObjectCreation();
          if (this.$attrs.nextForm) {
            this.$emit("open-next-form", {
              createdTechPointData: technicalPointData.data.data[0],
              techPointGeom: this.dataToSend.node.text_geom
            });
          }
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
          this.loadingSave = false;
        });
    },

    createDataToSend() {
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        status: this.objectData.tp_status,
        progress: this.objectData.tp_progress,
        physical_type: "V",
        technical_point_type: "V",
        logical_type: "T" //TODO - Remove when removed required from back-end
      };

      if (this.linkObjectToPathway.split) {
        this.dataToSend.node.delete_pathways_association = "false";
        this.dataToSend.node.pathway = this.linkObjectToPathway.pathway;
      }
      this.placeObjectDataInDataToSend();
    },
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/VirtualForm.vue